export const ProductDataMethodENMapping = {
  "Regenerante (Hairloss Control)": {
    color: "#B9A5DE",
    Product: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Flabiosthetique_product1.jpg?alt=media",
      description: "Intensive treatment with active ingredients for hair growth",
      value: "regenerante_hairloss_control_method",
      title: "Regenerante (Hairloss Control)",
      items: [
        {
          step: "Step 1",
          title: "Hairloss Control Shampoo",
          description:
            "This gentle shampoo revitalizes the hair roots, makes the hair more resilient, and helps prevent hair loss.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep1_regenerante.jpg?alt=media",
          value: "hairloss_control_shampoo",
        },
        {
          step: "Step 2",
          title: "Hairloss Control Scalp Lotion",
          description:
            "The scalp lotion slows down the aging process, promotes hair growth, improves hair density, and helps prevent hair loss.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep2_regenerante.jpg?alt=media",
          value: "hairloss_control_scalp_lotion",
        },
        {
          step: "Step 3",
          title: "Hairloss Control Scalp Concentrate",
          description:
            "The scalp concentrate revitalizes the hair roots and extends the hair's life cycle.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep3_regenerante.jpg?alt=media",
          value: "hairloss_control_scalp_concentrate",
        },
        {
          step: "Step 4",
          title: "Anti-Grey Elixir",
          description:
            "This unique scalp elixir revitalizes graying hair and helps restore its natural color.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep4_regenerante.jpg?alt=media",
          value: "anti_grey_elixir",
        },
        {
          step: "Step 5",
          title: "Fortifying Shampoo",
          description:
            "This gentle shampoo strengthens the hair roots, restores vitality to weakened, brittle hair, and prepares the scalp for subsequent treatment to combat hair loss and hair growth disorders.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep5_regenerante.jpg?alt=media",
          value: "fortifying_shampoo",
        },
        {
          step: "Step 6",
          title: "Fortifying Scalp Concentrate",
          description:
            "The scalp concentrate increases the supply of nutrients to the hair roots, helps prevent hair loss, and promotes thicker, stronger hair.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep6_regenerante.jpg?alt=media",
          value: "fortifying_scalp_concentrate",
        },
        {
          step: "Step 7",
          title: "Vitalising Scalp Concentrate",
          description:
            "This ampoule treatment nourishes the scalp and noticeably and visibly improves the quality of hair that has lost its volume, bounce, and resilience due to deficiencies in essential trace elements, minerals, and vitamins.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep7_regenerante.jpg?alt=media",
          value: "vitalising_scalp_concentrate",
        },
        {
          step: "Step 8",
          title: "Fortifying Aroma Complex",
          description:
            "The aroma complex harnesses the therapeutic properties of essential oils to stimulate scalp function, promote healthy hair growth, and provide a sense of harmonious well-being.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep8_regenerante.jpg?alt=media",
          value: "fortifying_aroma_complex",
        },
        {
          step: "Step 9",
          title: "Hair & Nail Strengthening Food Supplement",
          description:
            "This dietary supplement helps effectively treat hair loss and brittle nails from the inside out and promotes the growth of beautiful, healthy hair and nails.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep9_regenerante.jpg?alt=media",
          value: "hair_nail_strengthening_food_supplement",
        },
      ],
    },
    Treatment: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FTreatments%2FKopfhautmassage%20mit%20Ampulle.jpg?alt=media",
      description: "Scalp massage with an ampoule",
      value: "kopfhautmassage_mit_ampulle",
    },
  },
  "Sensitive (Dandruff)": {
    color: "#E390A1",
    Product: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Flabiosthetique_product2.jpg?alt=media",
      description: "Synergy care for dandruff and sensitive scalps",
      value: "sensitive_dandruff_method",
      title: "Sensitive",
      items: [
        {
          step: "Step 1",
          title: "Calming Lipokerine E Shampoo",
          description:
            "This fragrance-free shampoo gently cleanses, soothes sensitive scalps, and restores damaged hair.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep1_sensitive.jpg?alt=media",
          value: "calming_lipokerine_e_Shampoo",
        },
        {
          step: "Step 2",
          title: "Calming Scalp Lotion",
          description:
            "This soothing lotion calms stressed scalps, relieves irritation, prevents dandruff, and reduces the susceptibility of sensitive scalps to irritation.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep2_sensitive.jpg?alt=media",
          value: "calming_scalp_lotion",
        },
        {
          step: "Step 3",
          title: "Calming Aroma Complex",
          description:
            "The Aromakomplex harnesses the therapeutic powers of essential oils to restore sensitive scalps to their natural balance and enhance overall well-being.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep3_sensitive.jpg?alt=media",
          value: "calming_aroma_complex",
        },
        {
          step: "Step 4",
          title: "Purifying Dandruff Shampoo",
          description:
            "This fragrance-free shampoo gently and thoroughly removes dandruff and prevents it from returning.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep4_sensitive.jpg?alt=media",
          value: "purifying_dandruff_shampoo",
        },
        {
          step: "Step 5",
          title: "Babybios Conditioning Spray",
          description:
            "This lightweight leave-in conditioning spray pampers delicate hair and sensitive scalps with soothing ingredients and an extra dose of moisture.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep5_sensitive.jpg?alt=media",
          value: "babybios_conditioning_spray",
        },
      ],
    },
    Treatment: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FTreatments%2FKopfhautpeeling.jpg?alt=media",
      description: "Scalp scrub",
      value: "kopfhautpeeling",
    },
  },
  "Sensitive (Sensitive)": {
    color: "#E390A1",
    Product: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Flabiosthetique_product3.jpg?alt=media",
      description: "Synergy care for dandruff and sensitive scalps",
      value: "sensitive_sensitive_method",
      title: "Sensitive",
      items: [
        {
          step: "Step 1",
          title: "Calming Lipokerine E Shampoo",
          description:
            "This fragrance-free shampoo gently cleanses, soothes sensitive scalps, and restores damaged hair.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep1_sensitive.jpg?alt=media",
          value: "calming_lipokerine_e_Shampoo",
        },
        {
          step: "Step 2",
          title: "Calming Scalp Lotion",
          description:
            "This soothing lotion calms stressed scalps, relieves irritation, prevents dandruff, and reduces the susceptibility of sensitive scalps to irritation.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep2_sensitive.jpg?alt=media",
          value: "calming_scalp_lotion",
        },
        {
          step: "Step 3",
          title: "Calming Aroma Complex",
          description:
            "The Aromakomplex harnesses the therapeutic powers of essential oils to restore sensitive scalps to their natural balance and enhance overall well-being.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep3_sensitive.jpg?alt=media",
          value: "calming_aroma_complex",
        },
        {
          step: "Step 4",
          title: "Purifying Dandruff Shampoo",
          description:
            "This fragrance-free shampoo gently and thoroughly removes dandruff and prevents it from returning.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep4_sensitive.jpg?alt=media",
          value: "purifying_dandruff_shampoo",
        },
        {
          step: "Step 5",
          title: "Babybios Conditioning Spray",
          description:
            "This lightweight leave-in conditioning spray pampers delicate hair and sensitive scalps with soothing ingredients and an extra dose of moisture.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep5_sensitive.jpg?alt=media",
          value: "babybios_conditioning_spray",
        },
      ],
    },
    Treatment: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FTreatments%2FKopfhautmassage%20mit%20Lotion.jpg?alt=media",
      description: "Scalp massage with lotion",
      value: "kopfhautmassage_mit_lotion",
    },
  },
  Clarifiante: {
    color: "#A6D4AC",
    Product: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Flabiosthetique_product4.jpg?alt=media",
      description:
        "Balancing and clarifying care for oily and damp scalps",
      value: "clarifiante_method",
      title: "Clarifiante",
      items: [
        {
          step: "Step 1",
          title: "Balancing Lipokerine A Shampoo",
          description:
            "This balancing shampoo cleanses gently yet thoroughly, removes excess sebum from the scalp, regulates sebum production, and prevents the hair from becoming greasy too quickly.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep1_clarifiante.jpg?alt=media",
          value: "balancing_lipokerine_a_shampoo",
        },
        {
          step: "Step 2",
          title: "Moisture Control Shampoo",
          description:
            "While gently cleansing the scalp and hair, this shampoo reduces sweat secretion from the pores of the scalp and provides long-lasting freshness.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep2_clarifiante.jpg?alt=media",
          value: "moisture_control_shampoo",
        },
        {
          step: "Step 3",
          title: "Moisture Control Scalp Lotion",
          description:
            "The conditioning lotion neutralizes the harsh substances released by heavy sweating and soothes the scalp.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep3_clarifiante.jpg?alt=media",
          value: "moisture_control_scalp_lotion",
        },
        {
          step: "Step 4",
          title: "Refreshing Aroma Complex",
          description:
            "The Aromakomplex harnesses the therapeutic properties of essential oils to clarify oily or damp scalps and provide a lasting feeling of freshness.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep4_clarifiante.jpg?alt=media",
          value: "refreshing_aroma_complex",
        },
      ],
    },
    Treatment: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FTreatments%2FKopfhautmassage%20mit%20Lotion.jpg?alt=media",
      description: "Scalp massage with lotion",
      value: "kopfhautmassage_mit_lotion",
    },
  },
  Hydratante: {
    color: "#82C7E6",
    Product: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Flabiosthetique_product5.jpg?alt=media",
      description: "Moisturizing care for dry scalp",
      value: "hydratante_method",
      title: "Hydratante",
      items: [
        {
          step: "Step 1",
          title: "Restoring Lipokerine B Shampoo",
          description:
            "This gently cleansing shampoo strengthens the scalp's natural hydrolipid film, helps retain moisture, and protects the scalp and hair from drying out.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep1_hydratante.jpg?alt=media",
          value: "restoring_lipokerine_b_shampoo",
        },
        {
          step: "Step 2",
          title: "Restoring Scalp Lotion",
          description:
            "This moisturizing scalp treatment deeply hydrates the skin, locks in moisture for long-lasting results, and strengthens the skin's natural protective barrier.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep2_hydratante.jpg?alt=media",
          value: "restoring_scalp_lotion",
        },
        {
          step: "Step 3",
          title: "Restoring Scalp Oil",
          description:
            "Nourishing oils regenerate the scalp, strengthen its natural barrier function, and relieve dryness-related tightness and irritation.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep3_hydratante.jpg?alt=media",
          value: "restoring_scalp_oil",
        },
        {
          step: "Step 4",
          title: "Energising Aroma Complex",
          description:
            "The aroma complex harnesses the therapeutic properties of essential oils to stimulate scalp function, rejuvenate dry skin, and provide an invigorating sense of well-being.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep4_hydratante.jpg?alt=media",
          value: "energising_aroma_complex",
        },
      ],
    },
    Treatment: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FTreatments%2FKopfhautmassage%20mit%20Lotion.jpg?alt=media",
      description: "Scalp massage with lotion",
      value: "kopfhautmassage_mit_lotion",
    },
  },
};

export const ProductDataSolutionENMapping = {
  "Long Hair": {
    color: "#B60056",
    Product: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Flabiosthetique_product6.jpg?alt=media",
      description: "Intensive care and all-around protection for long hair",
      value: "long_hair_solution",
      title: "Long Hair",
      items: [
        {
          step: "Step 1",
          title: "Long Hair Protective Volumising Shampoo",
          description:
            "This gentle micellar shampoo deeply cleanses, balances the hair's structure, protects against harmful environmental factors, and adds volume to the hair.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep1_longhair.jpg?alt=media",
          value: "long_hair_protective_volumising_shampoo",
        },
        {
          step: "Step 2",
          title: "Long Hair Protective Softening Shampoo",
          description:
            "This gentle micellar shampoo deeply cleanses, balances the hair's structure, protects against harmful environmental factors, and leaves hair feeling soft and supple.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep2_longhair.jpg?alt=media",
          value: "long_hair_protective_softening_shampoo",
        },
        {
          step: "Step 3",
          title: "Long Hair Growth Booster",
          description:
            "This intensive treatment for hair roots and the scalp stimulates the activity of hair-producing cells and accelerates the growth of healthy, strong hair.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep3_longhair.jpg?alt=media",
          value: "Long Hair Growth Booster",
        },
        {
          step: "Step 4",
          title: "Long Hair Detangler",
          description:
            "This multi-action spray-on serum provides long hair with weightless moisture and nourishment, balances the hair's texture in just a few minutes, and detangles it.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep4_longhair.jpg?alt=media",
          value: "Long Hair Detangler",
        },
        {
          step: "Step 5",
          title: "Long Hair Protective Repair Mask",
          description:
            "Nutrients and conditioning agents strengthen the hair from the inside out and protect it from the outside.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep5_longhair.jpg?alt=media",
          value: "Long Hair Protective Repair Mask",
        },
        {
          step: "Step 6",
          title: "Long Hair Protective Conditioning Fluid",
          description:
            "Applied in a flash, this leave-in conditioning fluid moisturizes the hair, evens out texture, and protects it from breakage, pollutants, and other harmful environmental factors.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep6_longhair.jpg?alt=media",
          value: "Long Hair Protective Conditioning Fluid",
        },
        {
          step: "Step 7",
          title: "Long Hair Weightless Conditioning Oil",
          description:
            "This precious oil provides long hair with weightless moisture and nourishment, leaving it smooth and giving it an intense shine.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep7_longhair.jpg?alt=media",
          value: "Long Hair Weightless Conditioning Oil",
        },
        {
          step: "Step 8",
          title: "Long Hair Refreshing Dry Shampoo",
          description:
            "With the finest rice starch powder, Refresh Dry Shampoo absorbs excess oil. It naturally refreshes both the roots and the lengths of your hair.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep8_longhair.jpg?alt=media",
          value: "Long Hair Refreshing Dry Shampoo",
        },
      ],
    },
    Treatment: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FTreatments%2FIntensivhaarpflege.jpg?alt=media",
      description: "Intensive hair care",
      value: "intensivhaarpflege",
    },
  },
  "Structure Repair": {
    color: "#5CA3B4",
    Product: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Flabiosthetique_product7.jpg?alt=media",
      description:
        "Nourishing care for dry, severely damaged hair",
      value: "structure_repair_solution",
      title: "Structure Repair",
      items: [
        {
          step: "Step 1",
          title: "Structure Repair Nourishing Shampoo",
          description:
            "This moisturizing shampoo helps restore balance to the hair's texture and leaves dry, damaged hair wonderfully smooth and silky-shiny.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep1_structurerepair.jpg?alt=media",
          value: "Structure Repair Nourishing Shampoo",
        },
        {
          step: "Step 2",
          title: "Structure Repair Nourishing Conditioner",
          description:
            "Enriched with precious oils, this conditioner nourishes dry, severely damaged hair, moisturizes it, and ensures maximum softness, improved manageability, and shine.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep2_structurerepair.jpg?alt=media",
          value: "Structure Repair Nourishing Conditioner",
        },
        {
          step: "Step 3",
          title: "Structure Repair Nourishing Conditioning Spray",
          description:
            "As soon as it is sprayed on, this intensely nourishing leave-in spray nourishes damaged hair with valuable oils, repairs structural damage, and makes it easier to comb.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep3_structurerepair.jpg?alt=media",
          value: "Structure Repair Nourishing Conditioning Spray",
        },
        {
          step: "Step 4",
          title: "Structure Repair Nourishing Mask",
          description:
            "Precious oils and nutrients deeply repair severely damaged hair, seal its surface, and leave it shiny and smooth.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep4_structurerepair.jpg?alt=media",
          value: "Structure Repair Nourishing Mask",
        },
        {
          step: "Step 5",
          title: "Structure Repair Hydrating Drops",
          description:
            "Whether used on their own or to enhance your regular hair care routine, these innovative drops nourish dry, damaged hair with an extra dose of moisture.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep5_structurerepair.jpg?alt=media",
          value: "Structure Repair Hydrating Drops",
        },
      ],
    },
    Treatment: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FTreatments%2FIntensivhaarpflege.jpg?alt=media",
      description: "Intensive hair care",
      value: "intensivhaarpflege",
    },
  },
  "Colour Protection": {
    color: "#DC7597",
    Product: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Flabiosthetique_product8.jpg?alt=media",
      description:
        "Care and protection for colored and chemically treated hair",
      value: "colour_protection_solution",
      title: "Colour Protection",
      items: [
        {
          step: "Step 1",
          title: "Colour Protection Shine Restoring Pre-Shampoo Treatment",
          description:
            "This intensely nourishing pre-wash treatment protects the hair from moisture and color loss during shampooing, leaving it wonderfully smooth and with a healthy shine.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep1_colourprotection.jpg?alt=media",
          value: "Colour Protection Shine Restoring Pre-Shampoo Treatment",
        },
        {
          step: "Step 2",
          title: "Colour Protection Shine Restoring Volumising Shampoo",
          description:
            "This sulfate-free shampoo cleanses very gently, protects hair color from fading and washing out, and ensures long-lasting color vibrancy.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep2_colourprotection.jpg?alt=media",
          value: "Colour Protection Shine Restoring Volumising Shampoo",
        },
        {
          step: "Step 3",
          title: "Colour Protection Shine Restoring Softening Shampoo",
          description:
            "This gentle shampoo cleanses colored, damaged hair and provides it with moisture and nourishment.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep3_colourprotection.jpg?alt=media",
          value: "Colour Protection Shine Restoring Softening Shampoo",
        },
        {
          step: "Step 4",
          title: "Colour Protection Shine Restoring Conditioner",
          description:
            "Without weighing hair down, this conditioner detangles and conditions chemically treated hair, locks color pigments inside the hair shaft, protects against harmful environmental factors, and ensures softness, vibrant color, and shine.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep4_colourprotection.jpg?alt=media",
          value: "Colour Protection Shine Restoring Conditioner",
        },
        {
          step: "Step 5",
          title: "Colour Protection Shine Restoring Conditioning Fluid",
          description:
            "The leave-in fluid with built-in heat protection deeply nourishes and conditions the hair.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep5_colourprotection.jpg?alt=media",
          value: "Colour Protection Shine Restoring Conditioning Fluid",
        },
        {
          step: "Step 6",
          title: "Colour Protection Structure Restoring Treatment",
          description:
            "In two phases, this intensive hair care treatment repairs and restores the internal and external structure of chemically damaged hair, strengthens the hair, prevents breakage, and protects the hair from harmful environmental factors and premature color loss.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep6_colourprotection.jpg?alt=media",
          value: "Colour Protection Structure Restoring Treatment",
        },
      ],
    },
    Treatment: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FTreatments%2FIntensivhaarpflege.jpg?alt=media",
      description: "Intensive hair care",
      value: "intensivhaarpflege",
    },
  },
  Curl: {
    color: "#DF5F13",
    Product: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Flabiosthetique_product9.jpg?alt=media",
      description: "Care for curly hair",
      value: "curl_solution",
      title: "Curl",
      items: [
        {
          step: "Step 1",
          title: "Curl Activating Shampoo",
          description:
            "This gently cleansing shampoo revitalizes and energizes curls right from the first wash, thanks to extra moisture and an exclusive polymer.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep1_curl.jpg?alt=media",
          value: "Curl Activating Shampoo",
        },
        {
          step: "Step 2",
          title: "Curl Activating Repair Mask",
          description:
            "This deeply nourishing hair mask repairs and strengthens the curl structure with natural nutrients and protects the hair's surface from weather and environmental factors.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep2_curl.jpg?alt=media",
          value: "Curl Activating Repair Mask",
        },
        {
          step: "Step 3",
          title: "Curl Activating Conditioning Spray",
          description:
            "This easy-to-use spray lotion conditions and revitalizes curls, giving them lively vitality and bounce with flexible hold.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep3_curl.jpg?alt=media",
          value: "Curl Activating Conditioning Spray",
        },
        {
          step: "Step 4",
          title: "Curl Defining Styling Fluid",
          description:
            "This styling and finishing fluid tames unruly curls with deep-penetrating moisture.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep4_curl.jpg?alt=media",
          value: "Curl Defining Styling Fluid",
        },
      ],
    },
    Treatment: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FTreatments%2FIntensivhaarpflege.jpg?alt=media",
      description: "Intensive hair care",
      value: "intensivhaarpflege",
    },
  },
  Volume: {
    color: "#E6C22D",
    Product: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Flabiosthetique_product10.jpg?alt=media",
      description: "Care for fine, limp hair",
      value: "volume_solution",
      title: "Volume",
      items: [
        {
          step: "Step 1",
          title: "Volume Strengthening Shampoo",
          description:
            "This mild Strengthening Shampoo gently cleanses the hair, revitalizes fine, thin hair, strengthens and seals the hair shaft, and noticeably adds density and volume.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep1_volume.jpg?alt=media",
          value: "Volume Strengthening Shampoo",
        },
        {
          step: "Step 2",
          title: "Volume Weightless Conditioner",
          description:
            "This lightweight treatment revitalizes and strengthens fine hair, nourishes it with moisture, gently detangles it, and adds weightless volume.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep2_volume.jpg?alt=media",
          value: "Volume Weightless Conditioner",
        },
        {
          step: "Step 3",
          title: "Volume Strengthening Repair Mask",
          description:
            "This intensive conditioning mask deeply repairs and strengthens the hair without weighing it down, prevents breakage and split ends, and creates healthy volume.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep3_volume.jpg?alt=media",
          value: "Volume Strengthening Repair Mask",
        },
        {
          step: "Step 4",
          title: "Volume Strengthening Conditioning Spray",
          description:
            "This convenient leave-in conditioner nourishes and moisturizes your hair in an instant without weighing it down.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep4_volume.jpg?alt=media",
          value: "Volume Strengthening Conditioning Spray",
        },
      ],
    },
    Treatment: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FTreatments%2FIntensivhaarpflege.jpg?alt=media",
      description: "Intensive hair care",
      value: "intensivhaarpflege",
    },
  },
  "Frizz Control": {
    color: "#366099",
    Product: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Flabiosthetique_product11.jpg?alt=media",
      description: "Care & style for unruly hair",
      value: "frizz_control_solution",
      title: "Frizz Control",
      items: [
        {
          step: "Step 1",
          title: "Frizz Control Smoothing Shampoo",
          description:
            "Smoothing Shampoo soothes unruly hair even while you're washing it, tames its texture, and protects it from external factors.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep1_frizzcontrol.jpg?alt=media",
          value: "Frizz Control Smoothing Shampoo",
        },
        {
          step: "Step 2",
          title: "Frizz Control Smoothing Conditioner",
          description:
            "Smoothing Conditioner helps balance the moisture levels in unruly hair and nourishes it.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep2_frizzcontrol.jpg?alt=media",
          value: "Frizz Control Smoothing Conditioner",
        },
        {
          step: "Step 3",
          title: "Frizz Control Smoothing Styling Fluid",
          description:
            "Smoothing Styling Fluid tames unruly hair in a flash and leaves it looking shiny with a lively hold.",
          image:
            "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FProducts%2Fstep3_frizzcontrol.jpg?alt=media",
          value: "Frizz Control Smoothing Styling Fluid",
        },
      ],
    },
    Treatment: {
      image:
        "https://firebasestorage.googleapis.com/v0/b/iqonic-dev.appspot.com/o/customerConfigs%2Flabiosthetique%2Ffrontend%2Fassets%2FTreatments%2FIntensivhaarpflege.jpg?alt=media",
      description: "Intensive hair care",
      value: "intensivhaarpflege",
    },
  },
};
